/**
 * /devhub/file-ingestion — File ingestion (operator). Surface Layer (/01). REQ-001.91 Phase 3.
 * Live operator panel (DevHubFileIngestionPanel) wired to its useDevHub* hook over GET /api/control/registry/:name.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { DevHubFileIngestionPanel } from '../features/control-plane/DevHubFileIngestionPanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/file-ingestion')({ component: FileIngestionPage });

function FileIngestionPage() {
  return (
    <DevHubPanelPage
      title="File ingestion"
      subtitle="Workspace file ingestion and classification pipeline."
      status={{ label: 'live', live: true }}
    >
      <DevHubFileIngestionPanel />
    </DevHubPanelPage>
  );
}
